import Backbone from 'backbone';

export default Backbone.Collection.extend({
    searchAndRemove: function(search_options) {
        var models = this.where(search_options);

        if (models.length) {
            this.remove(models);
            return models;
        }
    },

    // deep clone the collection
    deepClone: function() {
        return new this.constructor(this.toJSON());
    },
});
